export const tembeaData = [
    {
        title: "Tembea High School Moments",
        images: [
            { src: 'assets/img/tembea/tembea0.jpg', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea1.png', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea2.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea3.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea4.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea5.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea6.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea7.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea8.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea9.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea10.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea11.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea12.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea13.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea14.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea15.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea16.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea17.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea18.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea19.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea20.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea21.jpg', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea22.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea23.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea24.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea25.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea26.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea27.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea28.jpg', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea29.JPG', alt: 'Tembea Beads High School' },
            { src: 'assets/img/tembea/tembea30.JPG', alt: 'Tembea Beads High School' },
        ],
    },
    {
        title: "Tembea High School Scouts Association",
        images: [
            { src: 'assets/img/tembea/Scouts1.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts2.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts3.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts4.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts5.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts6.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts7.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts8.JPG', alt: 'Tembea High School Scouts Association Gallery' },
            { src: 'assets/img/tembea/Scouts9.JPG', alt: 'Tembea High School Scouts Association Gallery' },
        ],
    },
    {
        title: "Tembea Beads High School Graduation",
        images: [
            { src: 'assets/img/tembea/grad1.JPG', alt: 'Tembea Beads High School Graduation Gallery' },
            { src: 'assets/img/tembea/grad2.JPG', alt: 'Tembea Beads High School Graduation Gallery' },
            { src: 'assets/img/tembea/grad3.JPG', alt: 'Tembea Beads High School Graduation Gallery' },
            { src: 'assets/img/tembea/grad4.JPG', alt: 'Tembea Beads High School Graduation Gallery' },
            { src: 'assets/img/tembea/grad5.JPG', alt: 'Tembea Beads High School Graduation Gallery' },
            { src: 'assets/img/tembea/grad6.jpg', alt: 'Tembea Beads High School Graduation Gallery' },
        ],
    },
    {
        title: "Tembea Beads High School Sports Club",
        images: [
            { src: 'assets/img/tembea/sports1.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
            { src: 'assets/img/tembea/sports2.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
            { src: 'assets/img/tembea/sports3.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
            { src: 'assets/img/tembea/sports4.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
            { src: 'assets/img/tembea/sports5.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
            { src: 'assets/img/tembea/sports6.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
            { src: 'assets/img/tembea/sports7.JPG', alt: 'Tembea Beads High School Sports Club Gallery' },
        ],
    },
];

export const accomplishments = [
    {
        title: "Mentorship with society of women engineers;",
        description: "The US Army provides expert professionals in the STEM field that share their knowledge on concept, application of the science knowledge in the classroom."
    },
    {
        title: "Mentorship with US Army Corp of engineers;",
        description: "Our girls receive one on one mentorship with society of women engineers. This improves the love for science and other STEM courses that are `believed` to be only suitable for their male counterparts."
    },
    {
        title: "Ashoka changemaker;",
        description: "Our students take part in change maker projects and have their stories published by Ashoka and world reader book publisher e.g Rebbeca is a climate change activist. Our school is Ashoka Changemaker."
    },
    {
        title: "Yale (yale young African scholars/yale young global scholars)",
        description: "It’s a leadership training organized by Yale University targeting young Africans and global leaders who are still in high school. This year out of applications from 40 different African countries according to the YALE report on the application, four of them were applications of our girls who created time to work with Mr. Lutta to brave the rigorous application process. One of the girls who applied for YALE YOUNG GLOBAL SCHOLARS did not qualify, but no harm she still has another chance. Two of the girls in grade 12; Jane Tome and Michelle Kegehi have been placed on the waitlist and we hope they will be considered. One girl, Emilly Lekupe qualified after her application sailed through. Although we would have wished for her to attend the face-to-face sessions in Zimbabwe, however, she was placed in the online program. This brings us to a total of 6 girls from Tembea to have joined the prestigious program of YALE YOUNG AFRICAN SCHOLARS."
    },
    {
        title: "HundrED youth Ambassador;",
        description: "This is an organization that improves education through innovation. We have one student participating in a HundrED youth Ambassador."
    },
    {
        title: "Representative on Olympic rugby;",
        description: "One of our girls Sheila Chajira, has represented us twice in the Olympic rugby in Tokyo."
    },
    {
        title: "Women opening their own businesses;",
        description: "One of our girls Ann Wamboi is a Geologist who set up her own company."
    },
    {
        title: "Writing with a Broadway Film Producer;",
        description: "Our girls have writing class with a well experienced broadway Film producer through weekly zoom."
    },
    {
        title: "Scouting;",
        description: "We have been participating in scouts’ competitions up to the National level. Currently we are the Kajiado county champions."
    },
    {
        title: "Sports;",
        description: "We have been participating in football tournaments and athletics where: We have participated in the under sixteen football tournaments up to the regional level. Currently we are the under sixteen cup holders of the rift valley region. In athletics three girls participated up to regional level in 5000m where one of them was selected to participate in the National level in Kisumu."
    },
    {
        title: "Book Club;",
        description: "We have a library with thousands and thousands of books and among them is 225 set books. Since 2013, we have been having book clubs. It has really helped girls with vocabularies and grammar."
    },
    {
        title: "Worldreader Book Publisher;",
        description: "One of our girls Rebecca Naisimoi wrote a book and it was published  by a world reader book publisher."
    },
    {
        title: "Individual mentorship with students from USA Top Universities;",
        description: "We have partnered with Curious Cardinal Org, that gives our students access to quality one-on-one STEM focused mentorship with top university students."
    },
    {
        title: "Ellen MacArthur Foundation;",
        description: "Great news as our students submitted a ‘standout’ innovation to Ellen MacArthur Foundation onbuilding a circular economy. The reward includes a one-hour lesson with the foundation’s design consultant, a certificate for their submission and an article featuring their improved product design after the lesson with the design consultant."
    },
    {
        title: "ConnectHer Film Project;",
        description: "ConnectHer invests in women and girls by elevating their status. It amplifies the voices of Women &amp; Girls through film. One of our own Beryl Muga was announced among the ConnectHer Film Festival Finalists. Her project was based on women and environment and she did a film with our students at Tembea on our climate smart projects. We are very proud of her."
    },
    {
        title: "Music and Poetry;",
        description: `In the spirit of preserving our cultural values, every year we have Kenyan Music Festivals that are geared towards showcasing talents in various aspects including music, poetry, public speaking, playing instruments etc. At Tembea we pride ourselves in doing the same and participating in these festivals. Our girls did an exemplary job in the music festivals. #393 Ariana also presented the poem "Argument with God" by Henry Barlow. They all managed to proceed upto 3 levels of the festivals. We hope to go even further in 2024. One of our college girl, Rebecca, who joined college this year (Kabarak University) joined the college’s music team and participated in the competitions that went up to East African region level. She also composed a Maasai poem that won and was invited to present it to the President of Kenya at this years’ Gala. We are very proud.`
    }
];

export const tembeaVideos = [
    {
        title: "A Visit to the BEADS for Education High School",
        type: "video",
        src: "https://www.youtube.com/embed/o4Mbh1y1mBA"
    },
    {
        title: "Sponsors visit Tembea HS for the first graduating class of 2017",
        type: "video",
        src: "https://www.youtube.com/embed/2LI7wGr-Tlo"
    },
]

// FUNDING DETAILS/NEEDS DATA:
export const phaseDetails = {
    "2012 - 2013: Phase 1": {
        title: "FUNDING GOAL 2012 - 2013 (PHASE 1)",
        details: [
            { type: "paragraph", content: "Below is list of the items required;" },
            { type: "header", content: "Breakdown of Costs:" },
            { type: "item", content: { item: "Purchase 10 acre plot of land", cost: "$83,000" } },
            { type: "item", content: { item: "Build 4 classrooms (25’ x 35’)", cost: "$140,000" } },
            { type: "item", content: { item: "Build library", cost: "$52,000" } },
            { type: "item", content: { item: "Stock library", cost: "$5,000" } },
            { type: "item", content: { item: "Water tanks and water", cost: "$7,500" } },
            { type: "item", content: { item: "Install 2 greenhouses", cost: "$10,000" } },
            { type: "item", content: { item: "School registration and professional fees", cost: "$35,000" } },
            { type: "item", content: { item: "Fence 1 acre", cost: "$6,000" } },
            { type: "item", content: { item: "Architects drawings", cost: "$7,150" } },
            { type: "item", content: { item: "Night watchman and grounds keeper", cost: "$18,00" } },
            { type: "item", content: { item: "BEADS for Education Staff supervisor:", cost: "$15,000" } },
            { type: "item", content: { item: "Miscellaneous expenses", cost: "$1,500" } },
            { type: "total", content: { message: "TOTAL FUNDING REQUIRED PHASE 1", amount: "$364,450" } },
            { type: "received", content: { message: "FUNDING RECEIVED AS OF JUNE 2013", amount: "$348,600" } },
        ],
    },
    "2013 - 2016: Phase 2": {
        title: "FUNDING GOAL 2013 - 2016 (PHASE 2)",
        details: [
            { type: "paragraph", content: "Below is list of the items required;" },
            { type: "header", content: "Breakdown of Costs:" },
            { type: "item", content: { item: "Classrooms (eight 25’ x 30’ classrooms)", cost: "$240,000" } },
            { type: "item", content: { item: "Nursery and First Grade Classes", cost: "$30,000" } },
            { type: "item", content: { item: "Kitchen", cost: "$35,000" } },
            { type: "item", content: { item: "Administration Building", cost: "$60,000" } },
            { type: "item", content: { item: "Teacher Residence (12 teachers)", cost: "$55,000" } },
            { type: "item", content: { item: "Dorms (3)", cost: "$90,000" } },
            { type: "item", content: { item: "Dining Room", cost: "$30,000" } },
            { type: "item", content: { item: "Toilets and showers", cost: "$10,000" } },
            { type: "item", content: { item: "Shade structure", cost: "$3,000" } },
            { type: "item", content: { item: "Desks, Beds, Misc. Furniture", cost: "$10,000" } },
            { type: "item", content: { item: "Borehole (well)", cost: "$58,000" } },
            { type: "item", content: { item: "Generator", cost: "$28,000" } },
            { type: "item", content: { item: "Car", cost: "$25,000" } },
            { type: "item", content: { item: "Bus (30 person)", cost: "$35,000" } },
            { type: "item", content: { item: "Solar Panels (10)", cost: "$12,000" } },
            { type: "item", content: { item: "Landscaping and Fruit Trees", cost: "$10,000" } },
            { type: "item", content: { item: "Painting and finishing", cost: "$6,000" } },
            { type: "item", content: { item: "Maintenance", cost: "$5,000" } },
            { type: "item", content: { item: "Library (books and supplies)", cost: "$10,000" } },
            { type: "item", content: { item: "Text Books", cost: "$12,000" } },
            { type: "item", content: { item: "School and office supplies", cost: "$5,000" } },
            { type: "item", content: { item: "Computers (20 computers and 2 printers)", cost: "$10,500" } },
            { type: "item", content: { item: "Architect", cost: "$6,000" } },
            { type: "item", content: { item: "Licenses and registration", cost: "$25,000" } },
            { type: "item", content: { item: "Chickens, Milk Goats and Enclosures", cost: "$3,000" } },
            { type: "item", content: { item: "12 Teachers", cost: "$86,000" } },
            { type: "item", content: { item: "Project Manager", cost: "$15,000" } },
            { type: "item", content: { item: "Fence Property", cost: "TBD (depending on cost of solar fence)" } },
            { type: "item", content: { item: "Cows for Milk and Biogas for Cooking", cost: "TBD" } },
            { type: "total", content: { message: "TOTAL FUNDING REQUIRED PHASE 2", amount: "$914,500" } },
        ],
    },
    "2017: Phase 3": {
        title: "FUNDING GOAL 2017 (PHASE 3)",
        details: [
            { type: "paragraph", content: "Below is list of the items required;" },
            { type: "header", content: "Breakdown of Costs:" },
            { type: "item", content: { item: "2 Classrooms", cost: "$60,000" } },
            { type: "item", content: { item: "4 Dorms", cost: "$60,000" } },
            { type: "item", content: { item: "Teacher and Staff Residence", cost: "$30,000" } },
            { type: "item", content: { item: "Volunteer Residence", cost: "$40,000" } },
            { type: "total", content: { message: "TOTAL FUNDING REQUIRED PHASE 3", amount: "$190,000" } },
        ],
    },
    "Other Funding Opportunities": {
        title: "OTHER FUNDING OPPORTUNITIES",
        details: [
            { type: "paragraph", content: "Below is list of the items required;" },
            { type: "header", content: "Breakdown of Costs:" },
            { type: "item", content: { item: "Sponsor a girl (elementary through high school student)", cost: "$400/year" } },
            { type: "paragraph", content: "Sponsors are matched with one girl and continue until her education is completed." },
            { type: "item", content: { item: "Sponsor an intern or college student", cost: "$1,600/year" } },
            { type: "item", content: { item: "Sponsor a teacher – secondary level", cost: "$6,000/year" } },
            { type: "paragraph", content: "Each student or teacher will send you regular letters and updates on their progress at the end of each term. You can write, send presents and of course VISIT." },
            { type: "paragraph", content: "A name of your choice will be placed on the dedication plaque for your donation. Some sponsors plan to dedicate their donation in their name and in their sponsored girl’s name." },
            { type: "paragraph", content: "Food security – BEADS is planning to be 90% self sufficient like many of our partner schools by raising livestock and growing our own food. Projects will include:" },
            { type: "item", content: { item: "CHICKENS – for eggs and meat", cost: "TBD" } },
            { type: "item", content: { item: "COWS – for milk and bio-gas to provide cooking fuel and preserve woodlands", cost: "TBD" } },
            { type: "item", content: { item: "GOATS/SHEEP – to provide milk and meat", cost: "TBD" } },
            { type: "item", content: { item: "GREENHOUSES – for maize, kale, spinach, sweet potatoes, potatoes, tomatoes etc.", cost: "TBD" } },
        ],
    },
};